import {
  VcPinboardBreakpoint,
  VcPinboardConfig as IVcPinboardConfig
} from 'services/api-service'

type SortOrderType = 'MOST_VOTES' | 'MOST_RECENT' | 'LONGEST'

export class VcPinboardConfig implements IVcPinboardConfig {
  constructor(config: IVcPinboardConfig) {
    this.activeOnly = config.activeOnly
    this.breakpointsConfig = config.breakpointsConfig
    this.hoverTitleMaxLength = config.hoverTitleMaxLength
    this.limit = config.limit
    this.minCaptionCharCount = config.minCaptionCharCount
    this.minCaptionWordCount = config.minCaptionWordCount
    this.maxCaptionLength = config.maxCaptionLength
    this.progressiveLoading = config.progressiveLoading
    this.showCaption = config.showCaption
    this.showDatestamp = config.showDatestamp
    this.showReviewStars = config.showReviewStars
    this.sortOrder = config.sortOrder
    this.userNameMaxLength = config.userNameMaxLength
    this.widgetDivId = config.widgetDivId
  }

  activeOnly: boolean
  breakpointsConfig: Array<VcPinboardBreakpoint>
  hoverTitleMaxLength: number
  limit: number
  minCaptionCharCount: number
  minCaptionWordCount: number
  maxCaptionLength: number
  progressiveLoading: boolean
  showCaption: boolean
  showDatestamp: boolean
  showReviewStars: boolean
  sortOrder: SortOrderType
  userNameMaxLength: number
  widgetDivId: string
}

let defaultConfig: IVcPinboardConfig = {}
export function loadConfig(config: IVcPinboardConfig): void {
  defaultConfig = new VcPinboardConfig(config)
}
export { defaultConfig as default }
